const sections = ["Home", "About", "Products", "Features", "Contact"];

const scrollTo = (id: string) => {
  const el = document.getElementById(id.toLowerCase());
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export default function Footer() {
  return (
    <footer className="bg-[#F2F1EE] border-t border-gray-200">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="flex flex-col lg:flex-row gap-12 justify-between">
          {/* Brand */}
          <div className="lg:w-1/3">
            <div className="flex items-center gap-3 mb-4 cursor-pointer" onClick={() => scrollTo("home")}>
              <img
                src="https://public.readdy.ai/ai/img_res/d7cd33cb-b3f6-4ecd-9edd-36b11e99cf63.png"
                alt="CERTROM SRL"
                className="h-9 w-auto object-contain"
              />
              <span className="font-bold text-lg text-gray-900 tracking-wide">CERTROM SRL</span>
            </div>
            <p className="text-gray-500 text-sm leading-relaxed max-w-xs">
              A team of experts developing modern applications for the iOS platform. Enhancing user experience and improving mobile security.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-widest text-gray-400 mb-5">Navigation</h4>
            <ul className="flex flex-col gap-3">
              {sections.map((s) => (
                <li key={s}>
                  <button
                    onClick={() => scrollTo(s)}
                    className="text-gray-600 text-sm hover:text-gray-900 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {s}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-widest text-gray-400 mb-5">Products</h4>
            <ul className="flex flex-col gap-3">
              <li className="flex items-center gap-2 text-gray-600 text-sm">
                <i className="ri-shield-keyhole-line text-emerald-500 text-base" />
                VPN Application
              </li>
              <li className="flex items-center gap-2 text-gray-600 text-sm">
                <i className="ri-sparkling-2-line text-sky-500 text-base" />
                Cleaner Application
              </li>
            </ul>
            <h4 className="text-xs font-bold uppercase tracking-widest text-gray-400 mb-5 mt-8">Platform</h4>
            <div className="flex items-center gap-2 text-gray-600 text-sm">
              <i className="ri-apple-line text-gray-700 text-base" />
              iOS Exclusive
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-widest text-gray-400 mb-5">Contact</h4>
            <ul className="flex flex-col gap-4">
              <li className="flex flex-col gap-0.5">
                <span className="text-xs font-semibold uppercase tracking-widest text-gray-400">Email</span>
                <span className="text-gray-700 text-sm">info@certromsrl.com</span>
              </li>
              <li className="flex flex-col gap-0.5">
                <span className="text-xs font-semibold uppercase tracking-widest text-gray-400">Phone Number</span>
                <span className="text-gray-700 text-sm">+1 7405950984</span>
              </li>
              <li className="flex flex-col gap-0.5">
                <span className="text-xs font-semibold uppercase tracking-widest text-gray-400">Country</span>
                <span className="text-gray-700 text-sm">Romania</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Address Bar */}
      <div className="border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex flex-wrap gap-x-8 gap-y-2">
            {[
              { label: "Address", value: "CALEA 13 SEPTEMBRIE NR. 231A SC. 1 ET. 14 AP. 54" },
              { label: "City", value: "Bucharest" },
              { label: "ZIP", value: "050722" },
              { label: "Country", value: "Romania" },
            ].map((item) => (
              <div key={item.label} className="flex items-center gap-1.5">
                <span className="text-xs font-semibold uppercase tracking-widest text-gray-400">{item.label}:</span>
                <span className="text-gray-600 text-xs">{item.value}</span>
              </div>
            ))}
          </div>
          <p className="text-gray-400 text-xs whitespace-nowrap">
            &copy; {new Date().getFullYear()} CERTROM SRL. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
